import { getMenuByRouter } from '../utils/assist'
import Menu from './Menu'
import RESOURCE_TYPE from './resource-type'

// 动态资源菜单
export default {
    namespaced: true,

    state: {
        // res
        resTree: [],
        // menu route
        hasMenu: false,
        routes: [],
        flatRoutes: [],
        mapRoutes: {},
        namedRoutes: {},
        message: { menu: {} },
        homeRoute: null,
    },

    getters: {
        // 动态菜单列表
        menuList: (state, getters, rootState) => {
            return getMenuByRouter(state.routes)
        },

        // 用户权限
        auth: (state) => {
            return state.resTree.filter(v => !!v.uri || v.type == RESOURCE_TYPE.group)
        },
        
        // 获取当前路由的所有可见父级路由
        getRelativeRoutes: (state) => (route, namedRoutes) => {
            var homeName = Menu.options.homeName,
                homeItem,
                routeMatched = [route],
                namedRoutes = namedRoutes || state.namedRoutes,
                homeRoute = namedRoutes[homeName]
            
            if (homeRoute) {
                homeItem = {
                    icon: (homeRoute.meta && homeRoute.meta.icon) || '',
                    name: Menu.options.homeName,
                    meta: homeRoute.meta,
                }
            }

            var parent = namedRoutes[route.meta.parentName]

            while (parent) {
                routeMatched.unshift(parent)
                parent = namedRoutes[parent.meta.parentName]
            }

            if (homeRoute && routeMatched.some(item => item.name === homeName)) return [homeItem]

            // bread-hide检查
            let list = routeMatched.filter(item => {
                return (item.meta === undefined || !item.meta.hide) && item.meta.title
            }).map(item => {
                let meta = { ...item.meta }

                let obj = {
                    icon: (item.meta && item.meta.icon) || '',
                    name: item.meta.targetName || item.name,
                    meta: meta,
                }

                return obj
            })

            // ex: home / dir1 / dir2 / menu
            if(homeRoute){
                list.unshift({ ...homeItem, to: { name: homeItem.name } })
            }

            return list
        }
    },

    mutations: {
        // 设置资源权限
        setRes(state, list) {
            state.resTree = list
        },

        // 清空资源
        clearRes(state) {
            state.resTree = []

            state.hasMenu = false
            state.routes = []
            state.flatRoutes = []
            state.mapRoutes = {}
            state.message = {}
            state.homeRoute = null
        },

        // 设置系统菜单
        setMenu(state, menu) {
            state.hasMenu = true

            state.routes = menu.routes
            state.flatRoutes = menu.flatRoutes
            state.mapRoutes = menu.mapRoutes
            state.namedRoutes = menu.namedRoutes
            state.message = menu.message
            state.homeRoute = menu.homeRoute
        },
    },
}